export default __webpack_public_path__ + "static/media/MotElegy.2cb62de7.jpeg";